<template>
  <div class="statistics">
    <div class="text">
      <div class="monitor-header">
        <span>人员统计</span>
      </div>
      <div v-show="activeName == 2" style="text-align: right;margin: 10px 0 0 20px">
        当前人数：<span>{{ sum }}</span
      >人
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="区域人员" name="1">
          <div id="peopleArea" class="itemDiv-echart" />
        </el-tab-pane>
        <el-tab-pane label="二道门" name="2">
          <div class="table">
            <div class="table-er">
              <div>当前二道门</div>

            </div>
            <div class="tableLsit">
              <div
                class="tableOne"
                v-for="(item, index) in tableList"
                :key="index"
              >
                <span>{{ item.title }}</span
                >： <span>{{ item.value }}</span
                >人
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getPeople, getFindSirenTimelyData } from "@/api/worker.js";
import D3Config from "@/utils/D3Config";
import echarts from "echarts";

export default {
  name: "Gaojing",
  data() {
    return {
      drawer: true,
      activeName: "1",
      sum: 0,
      tableList: []
    };
  },
  props: {
    msg: String
  },
  created() {
    this.getFindSirenTimelyDataList();
  },
  mounted() {
    this.getEchartsData();
  },
  methods: {
    getEchartsData() {
      this.activeName = "1";
      let username = (this.username = this.D3Config.username);
      let password = (this.password = this.D3Config.password);
      getPeople(username, password).then(res => {
        const result = res.data.data;
        if (result) {
          let areaList = [];
          let worknameList = [];
          result.forEach(item => {
            areaList.push(item.areaTotals);
            worknameList.push(item.areaName);
          });
          const quyuChart = echarts.init(document.getElementById("peopleArea"));
          quyuChart.setOption({
            tooltip: {
              trigger: "axis",
              axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: "shadow" // 默认为直线，可选为：'line' | 'shadow'
              }
            },
            grid: {
              left: "3%",
              right: "4%",
              bottom: "3%",
              top: "8%",
              containLabel: true
            },
            xAxis: [
              {
                type: "category",
                data: worknameList,
                axisTick: {
                  alignWithLabel: true
                },
                axisLabel: {
                  textStyle: {
                    color: "#9494A1" //坐标值得具体的颜色
                  }
                }
              }
            ],
            yAxis: [
              {
                type: "value",
                axisLabel: {
                  textStyle: {
                    color: "#000" //坐标值得具体的颜色
                  }
                }
              }
            ],
            dataZoom: [
              {
                id: "dataZoomX",
                type: "slider",
                xAxisIndex: [0],
                filterMode: "filter"
              }
            ],
            series: [
              {
                name: "直接访问",
                type: "bar",
                barWidth: "30",
                itemStyle: {
                  emphasis: {
                    barBorderRadius: 30
                  },
                  normal: {
                    barBorderRadius:[30, 30, 0, 0],
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: "#83bff6" },
                      { offset: 0.5, color: "#188df0" },
                      { offset: 1, color: "#188df0" }
                    ]),
                    label: {

                      show: true, //开启显示
                      position: "top", //在上方显示
                      textStyle: {
                        //数值样式
                        color: "white",
                        fontSize: 16
                      }
                    }
                  }
                },
                data: areaList
              }
            ]
          });
        }
      });
    },
    getFindSirenTimelyDataList() {
      getFindSirenTimelyData(this.username, this.password).then(res => {
        const result = res.data;
        if (result.status_code === 100) {
          this.tableList = result.data;
          this.sum = this.tableList.reduce((prep, curr) => {
            return Number(curr.value) + prep;
          }, 0);
        }
      });
    },
    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style scoped>
  .monitor-header {
    width: 100%;
    height: 40px;
    text-align: center;
    background: #F4F4F4;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #333333;
    line-height: 40px;
  }
.statistics {
  width: 930px;
  height: 550px;
  position: absolute;
  top: 20%;
  left: 30%;
}
.text {
  width: 100%;
  height: 100%;
  padding: 20px;
  color: #333333;
  background: #ffffff;
}

.table {
  height: 100%;
  padding: 20px;
}
.table-er {
  display: flex;
  justify-content: space-between;
}
.tableLsit {
  width: 600px;
  display: flex;
  flex-wrap: wrap;
  margin-top: 20px;
}
.tableOne {
  width: 50%;
  height: 40px;
  font-size: 18px;
  line-height: 40px;
}
.itemDiv-echart {
  width: 900px;
  height: 400px;
}
</style>
